import React, { useRef } from "react";
import { BgImg, TextBox, Wrapper } from "./style";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLanguage } from "redux/reducers/languageReducer";
const Com1 = () => {
  const ref = useRef();
  const ref2 = useRef();
  useScrollFadeIn(ref, ref2);

  const { t } = useTranslation("landing");
  const language = useSelector(selectLanguage);
  return (
    <Wrapper>
      <div>
        <BgImg
          ref={ref2}
          className="fade-in-late"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/c0de7e14Landing_1.png"
          fetchPriority="high"
        ></BgImg>
      </div>
      <TextBox ref={ref} className="fade-in" language={language}>
        <div>{t("1-1")}</div>
        <div>{t("1-2")}</div>
        <div>
          <span>{t("1-3")} &nbsp;</span>
          <span>{t("1-4")}</span>
        </div>
      </TextBox>
    </Wrapper>
  );
};

export default Com1;
